import "./index.scss";
export default function Toggler({ className = "", onClick = () => {} }) {
  return (
    <i
      className={`Toggler position-relative d-flex flex-center cursor-pointer fs-1 bi bi-list ${className}`}
      onClick={onClick}
    />
  );
}
